export const PLANS = {
  PRO: "Pro",
  BASIC: "Basic"
};

export const TOTAL_AUTOMATED_INSTITUTIONS_ALLOWED = 1000;
